export const BANNER_ASPECT_RATIO = {
  SKELETON_DEFAULT: '--banner-aspect-ratio-size-0',
  SIZE_10: '--banner-aspect-ratio-size-10', // main pages
  SIZE_20: '--banner-aspect-ratio-size-20', // details pages
  SIZE_30: '--banner-aspect-ratio-size-30', // width 92%
  SIZE_40: '--banner-aspect-ratio-size-40', // width 66%
  SIZE_50: '--banner-aspect-ratio-size-50',
  DETAILS_BANNER: '--banner-aspect-ratio-details-banner', // content details banner shell
  LIVE_EVENTS_BANNER: '--banner-aspect-ratio-live-event',
  PARTNER_PRODUCT_BANNER: '--banner-aspect-ratio-partner-product',
  POSTER: '--banner-aspect-ratio-poster',
} as const
export type BANNER_ASPECT_RATIO =
  (typeof BANNER_ASPECT_RATIO)[keyof typeof BANNER_ASPECT_RATIO]
